<template>
  <div class="box">
    <table class="table is-fullwidth">
      <tr>
        <th>Name</th>
        <th>Email</th>
        <th>Assign</th>
      </tr>
      <tr v-for="(new_member_row, index) in new_member_list" :key="index">
        <td v-text="new_member_row.name"></td>
        <td v-text="new_member_row.email"></td>
        <td>
          <button class="button is-link" type="button" @click="assignToMember(new_member_row)">Assign</button>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  data () {
    return {
      new_member_list: []
    }
  },
  created () {
    if (this.getSessionItem('id_token') === null || this.getSessionItem('access_token') === null) {
      this.$router.push('/panel/logout')
    }
    this.getNewMember()
  },
  methods: {
    getNewMember () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyGetSession('trainee/get_new_member')
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.new_member_list = response.data.data
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    assignToMember (newMemberRow) {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('trainee/assign_to_member', {
        new_member_id: newMemberRow.id
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.getNewMember()
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/trainee/Home.vue